import React, { useMemo } from "react";
import DOMPurify from "dompurify";

const looksLikeHtml = (s) => typeof s === "string" && /<\/?[a-z][\s\S]*>/i.test(s);

// Renders admin-authored content. HTML (from the rich-text editor) is sanitized;
// legacy plain text is split into paragraphs on blank lines.
export default function RichText({ html, className = "" }) {
  const content = useMemo(() => {
    if (!html) return null;
    if (looksLikeHtml(html)) {
      return { __html: DOMPurify.sanitize(html, { USE_PROFILES: { html: true } }) };
    }
    return null;
  }, [html]);

  if (!html) return null;

  if (content) {
    return <div className={`rich-text ${className}`} dangerouslySetInnerHTML={content} data-testid="rich-text" />;
  }
  return (
    <div className={`rich-text ${className}`} data-testid="rich-text">
      {String(html).split("\n\n").map((p, i) => <p key={i}>{p}</p>)}
    </div>
  );
}
